import { StyleSheet, View, Text, Pressable} from "react-native";
import { ProductNode, Order } from "@datamodel";
import { useLanguage } from "@languageProvider";
import { useTheme } from "@themeProvider";
import { Typography, Spacing, Mixins, Icon, Commons } from "@styles";
import service from "@services";
import { parsePrice } from "@utils/helpers";
import { Button } from '@atoms';

const styles = StyleSheet.create({
    orderCard: {
        paddingVertical: Spacing.XS,
        alignItems: 'center'
    }
})

export const OrderCard = ({ order = Order.model, style, orderUrl, repeat, ...props }) => {
    const { useColor, useElevation } = useTheme();
    const { translate } = useLanguage();

    const [body, title, statusColor, primary] = useColor([
        'body',
        'title',
        Order.getColor(order),
        'primary',
    ]);

    const onPress = () => {
        if (orderUrl) {
            window.location = orderUrl;
        }
    }

    return (<Pressable onPress={onPress} style={[Mixins.HORIZONTAL, styles.orderCard, style]}>
        <View style={{ flex: 1 }}>
            <Text numberOfLines={1} style={[Typography.SUBTITLE, { color: title }]}>{Object.keys(order.purchases).length} {
                Object.keys(order.purchases).length > 1 ? translate('products') : translate('product')
            }</Text>
            <Text numberOfLines={1} style={[Typography.TITLE, { color: statusColor }]}>{parsePrice(order.total, '€')}</Text>
        </View>
        {!!repeat &&
            <Button onPress={repeat} icon="refresh" size="condensed" style={Commons.styles.squaredCondensedButton}/>
        }
    </Pressable>)
}
